/**
 * Social Lookup API client
 */

import { get, post } from './api';
import type { SocialPlatform, WorkerStatus, PlaceStatusMap } from '@/types/socialLookup';

interface ClickResponse {
  ok: boolean;
  workerStatus: WorkerStatus;
}

interface WorkerStatusResponse {
  workerStatus: WorkerStatus;
}

interface PlaceStatusResponse {
  statuses: PlaceStatusMap;
}

interface CompletedIdsResponse {
  placeIds: string[];
}

export async function recordClick(
  placeId: string,
  platform: SocialPlatform
): Promise<ClickResponse> {
  return post<ClickResponse>('/social-lookup/click', { placeId, platform });
}

export async function getWorkerStatus(): Promise<WorkerStatus> {
  const res = await get<WorkerStatusResponse>('/social-lookup/worker-status');
  return res.workerStatus;
}

export async function getPlaceStatus(placeIds: string[]): Promise<PlaceStatusMap> {
  if (placeIds.length === 0) return {};
  const res = await get<PlaceStatusResponse>(
    `/social-lookup/place-status?placeIds=${placeIds.join(',')}`
  );
  return res.statuses;
}

export async function getCompletedPlaceIds(): Promise<string[]> {
  const res = await get<CompletedIdsResponse>('/social-lookup/completed-place-ids');
  return res.placeIds;
}
